import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { Permiso } from "@/shared/types/permiso";
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

interface EditPermisosRequest {
    permisos: Record<Permiso, boolean>
};

export async function editPermisos(usuarioId: string, request: EditPermisosRequest) {
    await sleep(1000);
    await api.post("permisos/" + usuarioId, removeNullOrEmptyKeys(request));
}

export function useEditPermisosMutation(usuarioId: string, mutationConfig: MutationConfig<void, EditPermisosRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: data => editPermisos(usuarioId, data),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["permisos", usuarioId] });
        },
    })
}

export interface EditPermisosMutationProps {
    usuarioId: string,
    mutationConfig?: MutationConfig<void, EditPermisosRequest>,
    children?: (mutationResult: MutationResult<void, EditPermisosRequest>) => ReactNode
}

export function EditPermisosMutation({
    usuarioId,
    children,
    mutationConfig
}: EditPermisosMutationProps) {
    const mutationResult = useEditPermisosMutation(usuarioId, mutationConfig);
    return children && children(mutationResult);
}